module.exports = __webpack_public_path__ + "media/images/icons/filled/environment-31ec58455a3512110bc86d0009573d96.svg";